var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"max-w-3xl mx-auto flex flex-col md:flex-row py-8 md:py-12",class:{
    'justify-center': !_vm.heading
  }},[(_vm.heading)?_c('h2',{staticClass:"text-primary text-xl font-bold italic w-full md:w-1/4 mb-6 md:mb-0 pr-6"},[_vm._v("\n    "+_vm._s(_vm.heading)+"\n  ")]):_vm._e(),_c('div',{staticClass:"w-full md:w-3/4"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }